import { PawPrint, BadgeCheck, MapPin } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const verifiedShelters = [
  { name: "KTOZ Kraków", city: "Kraków" },
  { name: "Schronisko LPGK Legnica", city: "Legnica" },
  { name: "Koci Azyl Żagań", city: "Żagań" },
  { name: "Schronisko Kielce", city: "Kielce" },
  { name: "Schronisko Piotrków Tryb.", city: "Piotrków Tryb." },
  { name: "Schronisko Kiczarów", city: "Stargard" },
  { name: "Schronisko Chełm", city: "Chełm" },
  { name: "Schronisko Milanówek", city: "Milanówek" },
  { name: "Schronisko Borek", city: "Rzezawa" },
  { name: "Schronisko Ciapek", city: "Hajnówka" },
  { name: "Schronisko Sokółka", city: "Sokółka" },
  { name: "Fundacja Jedno Serce", city: "Szumowo" },
];

export const InstagramStory12Verified1 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />
      
      {/* Gradient overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(180deg, rgba(78,138,110,0.08) 0%, rgba(45,90,61,0.12) 100%)",
          zIndex: 1,
        }}
      />

      {/* Safe zone content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 60px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <div
            style={{
              fontSize: "180px",
              fontWeight: 800,
              color: "#4E8A6E",
              lineHeight: 0.85,
              textShadow: "0 8px 40px rgba(78,138,110,0.25)",
            }}
          >
            12
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              marginTop: "-8px",
            }}
          >
            <BadgeCheck style={{ width: "40px", height: "40px", color: "#4E8A6E" }} />
            <span style={{ fontSize: "42px", fontWeight: 800, color: "#2D5A3D" }}>
              zweryfikowanych!
            </span>
          </div>
        </div>

        {/* Shelters grid - 2 columns */}
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
            alignContent: "center",
          }}
        >
          {verifiedShelters.map((shelter, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.96)",
                borderRadius: "16px",
                padding: "16px 18px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                border: "1.5px solid rgba(78,138,110,0.15)",
              }}
            >
              <MapPin style={{ width: "22px", height: "22px", color: "#4E8A6E", flexShrink: 0 }} />
              <div style={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: 700,
                    color: "#2D5A3D",
                    lineHeight: 1.15,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {shelter.name}
                </span>
                <span style={{ fontSize: "18px", fontWeight: 500, color: "#6B8A7A" }}>
                  {shelter.city}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div style={{ textAlign: "center", marginTop: "32px" }}>
          <div
            style={{
              background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
              borderRadius: "24px",
              padding: "24px 40px",
              marginBottom: "20px",
            }}
          >
            <p style={{ fontSize: "30px", fontWeight: 700, color: "#FFFFFF", margin: 0 }}>
              Sprawdź ich potrzeby! 💚
            </p>
          </div>

          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
